import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.scss?vue&type=style&index=0&id=08b25788&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08b25788"]])

export default __exports__